
import { Alert, Badge, Checkbox, CheckboxOptionType, Col, Row, Select } from "antd";
import { SelectProps } from "antd/lib/select";
import React, { FC, useEffect, useMemo } from "react";
import _t from "../../lang/translate";
import { useEnums } from "../useEnum";
import { EnumItemType, EnumKeys } from "../../types/appTypes";
import { CheckboxGroupProps } from "antd/lib/checkbox";


export interface EnumCheckboxesProps extends CheckboxGroupProps {
  nameKey: EnumKeys;
  dataFilter?: (data: EnumItemType[]) => EnumItemType[] | null;
  defaultActiveFirstOption?: boolean;
  gridColumns?: number;
}

const EnumCheckboxes: FC<EnumCheckboxesProps> = ({
  value,
  onChange,
  dataFilter,
  nameKey,
  defaultActiveFirstOption,
  gridColumns,
  ...rest
}) => {
  const [enums, isLoading, isError] = useEnums(nameKey);

  useEffect(() => {
    if (enums && defaultActiveFirstOption && enums.length && !value) {
      if (onChange) {
        onChange([enums[0].id]);
      }
    }
  }, [value, enums, onChange]);

  const data = dataFilter && enums ? dataFilter(enums) : enums;

  const options = useMemo(() => {
    return (data ?? []).map<CheckboxOptionType>((enumItem: EnumItemType) => ({
      label: enumItem.title,
      value: enumItem.id,
    }));
  }, [data])

  return (
    <>
      {gridColumns ? (
        <Checkbox.Group
          onChange={onChange}
          value={value}
          {...rest}
          style={{ width: "100%" }}
        >
          <Row gutter={[4, 0]} style={{ width: "100%" }} wrap>
            {options.map(item => (
              <Col flex={`0 0 ${100 / gridColumns}%`} key={String(item.value)}>
                <Checkbox value={item.value}>{item.label}</Checkbox>
              </Col>
            ))}
          </Row>
        </Checkbox.Group>
      ) : (

        <Checkbox.Group
          options={options}
          onChange={onChange}
          value={value}
          {...rest}
        />
      )}
      {isError && <Alert message={_t("msg.could_not_fetch_options")} className="mt-1" type="error" closable />}
    </>
  );
};

export default EnumCheckboxes;
